import React from "react";
type CutPlanProps = {
  className?: string;
  dark?: boolean;
};
function CutPlan({
  className = "",
  dark = false
}: CutPlanProps) {
  const stroke = dark ? "#F7F5F0" : "#17283B";
  return <svg aria-hidden="true" className={`pointer-events-none ${className}`} viewBox="0 0 640 220" fill="none" preserveAspectRatio="none" data-id="element-179" data-mp="2dios4pq9owe0">
      <g stroke={stroke} strokeOpacity=".16" strokeWidth="1" data-id="element-180" data-mp="2higweq8mogdk">
        <path d="M0 28H640M0 110H640M0 192H640" data-id="element-181" data-mp="2mjd7povb74t0" />
        <path d="M54 0V220M214 0V220M408 0V220M590 0V220" data-id="element-182" data-mp="2ripts7ecw7uj" />
        <path d="M54 44H214V172H54zM240 28h168v66H240zM240 116h96v76h-96zM360 116h178v76H360z" data-id="element-183" data-mp="2rh50sm7owwys" />
        {Array.from({
        length: 15
      }).map((_, index) => <path key={index} d={`M${74 + index * 32} 24v${index % 2 === 0 ? 8 : 4}`} data-id="element-184" data-mp="3192bzsyp7oxi" data-mpi={index} />)}
      </g>
      <g stroke="#EC6E30" strokeOpacity=".55" strokeWidth="1.5" data-id="element-185" data-mp="35b5rqtsehfol">
        <path d="M420 104h12V92M420 180h12v12" data-id="element-186" data-mp="3a9gzmyz4xg46" />
        <path d="M418 102h-58v80h58" data-id="element-187" data-mp="3aa8vmawn9fuz" />
      </g>
    </svg>;
}
export { CutPlan };